/**
 * Provides JS functionality for tracking alert display.
 */
class sidebarmenuMobile extends DrupalBehavior {
  onContent(context) {
    const element = $('.sidebar-menu__mobile', context);
    const button = $('.sidebar-menu__mobile--toggle', context);
    button.on('click', (event) => {
      event.preventDefault();
      if (!element.hasClass('sidebar-menu__mobile--active')) {
        element.addClass('sidebar-menu__mobile--active');
      } else {
        element.removeClass('sidebar-menu__mobile--active');
      }
    });
  }
}

DrupalBehavior.register('camc.components', 'sidebarmenu_mobile', sidebarmenuMobile);
  